import React from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import CustomSelectInput from "../../../../components/common/CustomSelectInput";
import { accessTypes } from "../../../../helpers/Utils";

const washersStatusOptions = [
    { key: "all", value: "All", label: "All" },
    { key: "active", value: "Active", label: "Active" },
    { key: "inactive", value: "Inactive", label: "Inactive" }
];

const WashersFilter = ({ filters, onFiltersChange }) => {
    const { user } = useSelector(state => state.authUser);
    const { provider } = useSelector(state => state.providers);

    // Only render for users with appropriate access
    if (!accessTypes.includes(user?.accessType)) {
        return null;
    }

    // Prepare providers options for dropdown
    const providersOptions = provider ? Object.values(provider).map(prov => ({
        ...prov,
        value: prov.name,
        label: prov.name,
        key: prov.key || prov.id
    })) : [];

    return (
        <>
            <Colxx xxs="12" md="3" className='mb-3' >
                <Select
                    components={{ Input: CustomSelectInput }}
                    className="basic-multi-select"
                    placeholder="Filter by Worker Status"
                    value={washersStatusOptions.find(option => option.key === filters?.washersStatus)}
                    options={washersStatusOptions}
                    onChange={val => {
                        if (val) {
                            onFiltersChange({ ...filters, washersStatus: val.key });
                        } else {
                            onFiltersChange({ ...filters, washersStatus: 'all' });
                        }
                    }}
                />
            </Colxx>
            <Colxx xxs="12" md="3" className='mb-3' >
                <Select
                    isClearable={true}
                    components={{ Input: CustomSelectInput }}
                    className="basic-multi-select"
                    placeholder="Filter by Service Provider"
                    value={providersOptions.find(option => option.key === filters?.selectedProvider?.key)}
                    options={providersOptions}
                    onChange={val => {
                        if (val) {
                            onFiltersChange({ ...filters, selectedProvider: val });
                        } else {
                            onFiltersChange({ ...filters, selectedProvider: false });
                        }
                    }}
                />
            </Colxx>
        </>
    );
};

export default WashersFilter;